<template>
  <el-form-item label="客户名称：" prop="customerId">
    <el-select
      clearable
      filterable
      remote
      reserve-keyword
      placeholder="请选择客户名称"
      @focus="handleSelectBlur"
      @change="handleSelectChange"
      @clear="handleSelectClear"
      :remote-method="handleCustomSearch"
      :loading="selectData.loading"
      :value="searchCustomer"
    >
      <el-option
        v-for="item in selectList"
        :label="item.name"
        :value="item.uid"
        :key="item.uid"
      >
        <span style="float: left" class="select-item-left">{{
          [item.name, item.hospitalName, item.hospDeptName]
            .filter(Boolean)
            .join('-')
        }}</span>
        <!-- <div v-if="[item.name, item.hospitalName,item.hospDeptName].filter(Boolean).join('-').length > 40">
            <el-tooltip
              class="item custom-select-item"
              effect="dark"
              :content="[item.name, item.hospitalName,item.hospDeptName].filter(Boolean).join('-')"
              placement="top">
              <span style="float: left" class="select-item-left">{{ [item.name, item.hospitalName].filter(Boolean).join('-') }}</span>
            </el-tooltip>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.hospDeptName }}</span>
          </div>
        <div v-else>
          <span style="float: left" class="select-item-left">{{ [item.name, item.hospitalName].filter(Boolean).join('-') }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.hospDeptName }}</span>
        </div> -->
      </el-option>
      <el-option
        v-if="
          visitCustomerDataList.totalCount > selectData.pageSize &&
            selectData.pageIndex < visitCustomerDataList.totalPages
        "
        label="点击加载更多"
        value="点击加载更多"
        :disabled="true"
        style="cursor:pointer;"
      >
        <span @click="handleMoreCustomList()">点击加载更多</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    val: {
      type: String,
      default: '',
    },
    // uid: {
    //   type: String,
    //   default: '',
    // },
  },
  data() {
    return {
      isMore: false,
      selectData: {
        loading: false,
        query: '',
        pageIndex: 1,
        pageSize: 5,
      },
      selectList: [],
    };
  },
  computed: {
    ...mapGetters({
      visitCustomerDataList: 'visit/visitCustomerDataList',
    }),
    searchCustomer() {
      return this.val || this.selectData.query;
    },
  },
  watch: {
    selectList(val) {
      // this.$emit('listDataChange', val);
    },
  },
  methods: {
    ...mapActions({
      getVisitCustomerDataList: 'visit/getVisitCustomerDataList',
    }),
    handleSelectBlur() {
      if (this.val) return;
      this.selectData.pageIndex = 1;
      this.selectData.query = '';
      this.getCustomSelectList();
    },
    handleSelectChange(value) {
      this.$emit('change', value);
    },
    handleSelectClear() {
      this.selectData.query = '';
    },
    handleCustomSearch(query) {
      this.selectData.query = query;
      this.selectData.pageIndex = 1;
      this.getCustomSelectList();
    },
    getCustomSelectList() {
      this.getVisitCustomerDataList({
        // uid: this.uid,
        name: this.selectData.query,
        pageSize: this.selectData.pageSize,
        pageNumber: this.selectData.pageIndex,
      }).then(() => {
        if (this.selectData.pageIndex === 1) {
          this.selectList = [];
        }
        this.visitCustomerDataList.results.forEach((item) => {
          this.selectList.push(item);
        });
      });
    },
    handleMoreCustomList() {
      this.isMore = true;
      this.selectData.pageIndex += 1;
      this.getCustomSelectList();
    },
  },
};
</script>
